import { render, staticRenderFns } from "./FoodDiet.vue?vue&type=template&id=3fb1c635&"
import script from "./FoodDiet.vue?vue&type=script&lang=js&"
export * from "./FoodDiet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports